import { Card, Display, Text, useRebrand } from "@growtherapy/sprout-ui";
import PreSessionImage from "../../../assets/images/pre-session-image.svg?react";
import { VisitorDrawerState } from "../../state";
import { ClientMeasuresCta } from "./ClientMeasuresCta";
import { VibesCtaWrapper } from "./VibesCta";
import { MoodSurveyCta } from "./MoodSurveyCta";
import { ReflectionTopicsCtaWrapper } from "./ReflectionTopicsCta";

export interface PreSessionPromptProps {
  callToActionContent: React.ReactNode;
}

export type CTAProps = { openDrawer: (drawer: VisitorDrawerState) => void };

export enum PreSessionPromptVariant {
  CLIENT_MEASURES = "CLIENT_MEASURES",
  MOOD_SURVEY = "MOOD_SURVEY",
  REFLECTION_TOPICS = "REFLECTION_TOPICS",
  VIBES = "VIBES",
}

export const VariantComponents: Record<
  PreSessionPromptVariant,
  React.FC<{
    openDrawer: (drawer: VisitorDrawerState) => void;
  }>
> = {
  [PreSessionPromptVariant.CLIENT_MEASURES]: ClientMeasuresCta,
  [PreSessionPromptVariant.MOOD_SURVEY]: MoodSurveyCta,
  [PreSessionPromptVariant.VIBES]: VibesCtaWrapper,
  [PreSessionPromptVariant.REFLECTION_TOPICS]: ReflectionTopicsCtaWrapper,
};

export function PreSessionPrompt({
  callToActionContent,
}: PreSessionPromptProps) {
  const isRebrand = useRebrand();

  return (
    <Card className="flex flex-col mobile:border-x rounded-xl items-center max-w-[38rem] gap-y-10 sm:p-10">
      {!isRebrand && (
        <div className="hidden sm:block">
          <PreSessionImage aria-label="A light purple sketch of a pair of hands clasped together." />
        </div>
      )}

      <div className="flex flex-col gap-y-4 items-center">
        {isRebrand ? (
          <Display.Small>You&apos;re in the right place.</Display.Small>
        ) : (
          <Text as="h2" variant="lg" className="font-medium">
            You&apos;re in the right place.
          </Text>
        )}

        <Text className="text-neutral-700 text-center">
          You&apos;ll be notified when your provider is ready to start your
          session. They have a 10-min grace period.
        </Text>

        {callToActionContent}
      </div>
    </Card>
  );
}

export function PreSessionPromptWrapper({
  variant,
  openDrawer,
}: {
  variant: PreSessionPromptVariant;
  openDrawer: (drawer: VisitorDrawerState) => void;
}) {
  const CallToAction = VariantComponents[variant];
  return (
    <PreSessionPrompt
      callToActionContent={<CallToAction openDrawer={openDrawer} />}
    />
  );
}
